export const SET_PICK_A_SEAT_BEST_AVAILABLE_WARNING =
    'setPickASeatBestAvailableWarning';
export const CLEAR_PICK_A_SEAT_BEST_AVAILABLE_WARNING =
    'clearPickASeatBestAvailableWarning';

export const ORDER_STATUS_POLLING_PERIOD_IN_MS = 250;
export const ORDER_STATUS_POLLING_TIMEOUT_IN_MS = 5 * 60 * 1000; // 5 minutes
